import { get, httpDelete, patch, post } from '../../utils/http';

// Rule Sets API
export const fetchComplianceRuleSets = ({ accountId, ...filters }) =>
  get(`/accounts/${accountId}/rules-engine/rule-sets`, { params: filters });

export const addComplianceRuleSet = ({ accountId, ...params }) =>
  post(`/accounts/${accountId}/rules-engine/rule-sets`, params);

export const updateComplianceRuleSet = ({ accountId, ruleSetId, ...params }) =>
  patch(`/accounts/${accountId}/rules-engine/rule-sets/${ruleSetId}`, params);

export const deleteComplianceRuleSet = ({ accountId, ruleSetId }) =>
  httpDelete(`/accounts/${accountId}/rules-engine/rule-sets/${ruleSetId}`);

// Rules API
export const fetchComplianceRules = ({ accountId, ruleSetId }) =>
  get(`/accounts/${accountId}/rules-engine/rule-sets/${ruleSetId}/rules`);

export const addComplianceRule = ({ accountId, ruleSetId, ...params }) =>
  post(`/accounts/${accountId}/rules-engine/rule-sets/${ruleSetId}/rules`, params);

export const updateComplianceRule = ({ accountId, ruleSetId, ruleId, ...params }) =>
  patch(`/accounts/${accountId}/rules-engine/rule-sets/${ruleSetId}/rules/${ruleId}`, params);

export const deleteComplianceRule = ({ accountId, ruleSetId, ruleId }) =>
  httpDelete(`/accounts/${accountId}/rules-engine/rule-sets/${ruleSetId}/rules/${ruleId}`);

// Evaluation API
export const evaluateCompliance = ({ accountId, ...params }) =>
  post(`/accounts/${accountId}/rules-engine/evaluate`, params);

// Templates API
export const fetchComplianceTemplates = ({ accountId }) => get(`/accounts/${accountId}/rules-engine/templates`);
